// extracted by mini-css-extract-plugin
export var card = "product-card-module--card--n4kQg";
export var header = "product-card-module--header--Yhajp";
export var imageBox = "product-card-module--image-box--2oDe5";
export var labelBox = "product-card-module--label-box--A-xuS";
export var ratio = "product-card-module--ratio--yy7x+";
export var subheader = "product-card-module--subheader--TRUi7";